var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 3.55H15.15M11.1946 3.55L10.6485 2.42338C10.2857 1.67501 10.1042 1.30082 9.79136 1.06745C9.722 1.01568 9.64848 0.969632 9.5716 0.92976C9.22512 0.75 8.80928 0.75 7.9776 0.75C7.12504 0.75 6.6988 0.75 6.34654 0.937296C6.26848 0.978808 6.19398 1.02672 6.12383 1.08054C5.80731 1.32336 5.6305 1.71124 5.27689 2.48701L4.79234 3.55",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9497 3.55005L13.4539 11.5701C13.3272 13.6192 13.2639 14.6437 12.7503 15.3804C12.4963 15.7445 12.1695 16.0519 11.7903 16.2828C11.0234 16.75 9.99691 16.75 7.94387 16.75C5.8882 16.75 4.86035 16.75 4.09295 16.282C3.71355 16.0506 3.38651 15.7427 3.13265 15.3779C2.61921 14.6401 2.55727 13.6141 2.43339 11.5622L1.94971 3.55005",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94971 12.35V7.55005",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94971 12.35V7.55005",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trash_red.fb4b12a2fb46ea099bb9da96abc68eb5.svg";
export { ForwardRef as ReactComponent };